import { createSlice } from "@reduxjs/toolkit"

export const initialUserState = {
  accountType: "INVESTOR", ///INVESTOR,WEALTH_PARTNER
  kycSteps: [],
  currentUserMenuType: "INVESTOR", ///INVESTOR,WEALTH_PARTNER
}

export const commonSlice = createSlice({
  name: "user",
  initialState: initialUserState,
  reducers: {
    setAccountType: (state, action) => {
      state.accountType = action.payload
    },
    setkycSteps: (state, action) => {
      state.kycSteps = action.payload
    },
    setCurrentUserMenuType: (state, action) => {
      state.currentUserMenuType = action.payload
    },
  },
})

// Action creators are generated for each case reducer function
export const { setAccountType, setkycSteps, setCurrentUserMenuType } =
  commonSlice.actions

export default commonSlice.reducer
